// Copyright (c) Bentley Systems
import { configureStore } from "@reduxjs/toolkit";
import authorizationReducer from "./authorization-slice";
import headersReducer from "./header-slice";
import entryScreenReducer from "./entry-screen-slice";
import sortOrderReducer from "./sort-filter-slice";
import confirmationReducer from "./confirmation-slice";
import formChangedReducer from "./form-changed-slice";
import formOpenReducer from "./form-open-slice";
import themeReducer from "./theme-slice";
import isErrorStateReducer from "./is-error-slice";
import isToastErrorStateReducer from "./is-toast-error-slice";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    authorization: authorizationReducer,
    sortOrder: sortOrderReducer,
    headers: headersReducer,
    entryScreen: entryScreenReducer,
    confirmation: confirmationReducer,
    formChanged: formChangedReducer,
    formOpen: formOpenReducer,
    theme: themeReducer,
    isError: isErrorStateReducer,
    isToastError: isToastErrorStateReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
